import axios from 'axios';

export type ProductKeyPayload = {
  key: string;
  user: {
    email: string;
    first_name: string;
    last_name: string;
    already_in_okta: boolean;
  };
  confirm_token_redemption?: boolean;
};

export type TokenRedemptionConfirmation = {
  code: 'confirmation_required';
  reason: 'individual_calibration_token_already_redeemed';
  key: string;
  token_type: 'test_template';
  calibration: true;
  previous_redemption: { redeemed_at: string };
  calibration_template: {
    class_version: 'class_2008' | 'class_2nd_edition';
    age_level_group: string;
    age_level_group_name: string;
  };
};

export function activateProductKeyV1(payload = {}) {
  return axios.post('/api/v1/product_keys', payload);
}

export function activateProductKey(payload = {}) {
  return axios.post('/api/v2/product_keys', payload);
}

export function activateProductKeyWithTestTemplate(
  testTemplateId: number,
  role: string,
  payload = {},
  pathway?: 'recertification' | 'transition',
  bundledUserCertificationIds?: number[]
) {
  return axios.post(
    `/api/v2/product_keys/?test_template_id=${testTemplateId}&role=${role}`,
    {
      ...payload,
      ...(pathway ? { pathway } : {}),
      ...(bundledUserCertificationIds !== undefined
        ? { bundled_user_certification_ids: bundledUserCertificationIds }
        : {})
    }
  );
}
